import { useQuery } from '@apollo/client/react'
import { GET_POST_PERFORMANCE } from '@/lib/operations/dashboard'
import type { PostPerformanceStats } from '@/lib/types'

export function usePostPerformance(
  clientId: string | null,
  filters?: { startDate?: string; endDate?: string }
) {
  const { data, loading, error } = useQuery<{ postPerformance: PostPerformanceStats }>(
    GET_POST_PERFORMANCE,
    {
      variables: { clientId, startDate: filters?.startDate, endDate: filters?.endDate },
      skip: !clientId,
    }
  )
  return { stats: data?.postPerformance ?? null, loading, error }
}
